<template>
    <div class="wrap">
        <!-- <header_index></header_index> -->
        <router-view></router-view>
        <!-- <footer_index></footer_index> -->
    </div>
</template>

<script>
// import header_index from "./header_index"
// import footer_index from "./footer_index"
export default {
    name: 'index',
    components: {
        // header_index,
        // footer_index
    }
};
</script>

<style scoped>
/* .wrap {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    } */
</style>
